import React from "react";
import PlacesAutocomplete from "react-places-autocomplete";
import { FieldRenderProps } from "react-final-form";
import cn from "classnames";
import { groupSuggestionStyled } from "../styles/style-config";

type Props<T> = FieldRenderProps<T, HTMLInputElement>;
export const PlaceAutocomplete = <T extends string>(props: Props<T>) => {
  const { value, onChange, ...other } = props.input;
  const hasError =
    ((props.meta.touched && props.meta.error) || props.meta.submitError) &&
    props.input.value;

  return (
    <PlacesAutocomplete
      value={value}
      onChange={onChange}
      onSelect={(value) => onChange(value)}
      debounce={300}
      searchOptions={{
        componentRestrictions: { country: "uk" },
      }}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps }) => (
        <div
          className={cn(groupSuggestionStyled, {
            filled: !!value,
          })}
        >
          {props.label && <label className={"label"}>{props.label}</label>}
          <input
            {...getInputProps({
              ...other,
              placeholder: props.placeholder,
              disabled: props.disabled,
            })}
          />
          <div
            className={cn("suggestions", {
              open: suggestions.length,
            })}
          >
            {suggestions.map((suggestion) => (
              <div
                {...getSuggestionItemProps(suggestion, {
                  className: cn("option", { active: suggestion.active }),
                })}
              >
                <span className={"coincidence"}>
                  {suggestion.description.slice(0, value.length)}
                </span>
                {suggestion.description.slice(value.length)}
              </div>
            ))}
          </div>
          {hasError && <p className={"error"}>{props.meta.submitError}</p>}
        </div>
      )}
    </PlacesAutocomplete>
  );
};
